<template>
    <div>
        <g-header></g-header>
        <div class="content-box" :style="{backgroundColor:bgColor}"><router-view></router-view></div>
        <g-footer></g-footer>
        <el-row class="compare-box" @click.native="showCompareSchool">
            <img src="../assets/images/pk.png" alt="院校对比" class="compare-img1">
            <img src="../assets/images/db.png" alt="院校对比" class="compare-img2">
            <el-row>
                <div class="compare-add">已添加</div>
                <div><span>{{compareSchoolList.length}}</span>所</div>
            </el-row>
        </el-row>
        <el-backtop class="banner-right" target="#app" :bottom="285">
            <el-row type="flex" class="banner-right-bottom">
                <el-col class="banner-right-code" v-if="showCode">
                    <img src="../assets/images/code.jpg" alt="二维码">
                    <p>微信扫描二维码<br>关注{{ website.name ? website.name : '荔枝生涯' }}</p>
                </el-col>
                <el-col class="banner-right-small-code" @mouseenter.native="showCodeHandler" @mouseleave.native="hideCodeHandler">
                    <img src="../assets/images/small_code.png">
                </el-col>
            </el-row>
            <el-row class="banner-right-top">
                <img src="../assets/images/top.png" alt="回到顶部">
            </el-row>
        </el-backtop>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import GHeader from '@/layout/GHeader';
    import GFooter from '@/layout/GFooter';
    export default {
        name: 'layout',
        components: {
            GHeader,
            GFooter
        },
        data () {
            return {
                showCode: false,
                bgColor: ''
            }
        },
        computed: {
            ...mapState({
                // isUserLogin: state => state.user.isUserLogin,
                // isLogin: state => state.user.isLogin,
				// isShowGk: state => state.user.isShowGk,
				// isShowVip: state => state.user.isShowVip,
				// isVipStr: state => state.user.isVipStr,
				// isShowAddVip: state => state.user.isShowAddVip,
				// isShowPlan: state => state.user.isShowPlan,
                // isShowUserName: state => state.user.isShowUserName,
                // isRegister: state => state.user.isRegister,
                // isForget: state => state.user.isForget,
                // isProvince: state => state.user.isProvince,
                // isCompare: state => state.user.isCompare,
                // isWechatPay: state => state.user.isWechatPay,
                compareSchoolList: state => state.user.compareSchoolList,
                token: state => state.user.token,
                website: state => state.user.website
            })
        },
        watch: {
            $route() {
                this.setColor()
            },
        },
        created () {
            this.setColor();
            this.checkVipHandler();
        },
        methods: {
            setColor() {
                if(this.$route.path == '/goal' || this.$route.path == '/interest' || this.$route.path == '/news' || this.$route.path == '/character' || this.$route.path == '/newsDetail' || this.$route.path == '/video' || this.$route.path == '/download' || this.$route.path == '/basicPlan' || this.$route.path == '/specialPlan' || this.$route.path == '/sergeant' || this.$route.path == '/highSchool'|| this.$route.path == '/guideDetail'|| this.$route.path == '/new_examination') {
                    this.bgColor = '#ffffff';
                } else if(this.$route.path == '/gk_guide') {
                    this.bgColor = '#f5f1ff';
                } else {
                    this.bgColor = '#f5f7fa';
                }
            },
            showCompareSchool() {
                if(!this.token) {
                    this.$store.commit('user/LOGINSTATUS', true);
                    return
                }
                if(this.compareSchoolList.length < 2) {
                    this.$message({
                        message: '至少添加2所院校',
                        type: 'warning'
                    })
                    return
                }
                this.$store.commit('user/COMPARESTATUS', true);
            },
            showCodeHandler() {
                this.showCode = true;
            },
            hideCodeHandler() {
                this.showCode = false;
            },
            checkVipHandler() {
                if(this.token) {
                    if(localStorage.getItem("hasLogin") !== 'false') {
                        this.$store.commit('user/SAVETOKEN','');
                        localStorage.removeItem("mobile");
                        localStorage.removeItem("gkInforObj");
                        localStorage.removeItem("ZHIYUANSTATUS");
                        localStorage.removeItem("head_img");
                        localStorage.removeItem("isVipStr");
                        localStorage.removeItem("isNewUser");
                        localStorage.removeItem("token");
                        localStorage.removeItem("vipType");
                        localStorage.removeItem("hasLogin");
                    } else {
                        this.$store.dispatch('user/GETINFOR');
                    }
                    // checkVip().then(res => {
                    //     if(res.data.is_vip == '0') {
                    //         this.$store.commit('user/VIPSTATUS', 'false');
                    //         localStorage.setItem("isVipStr", 'false',{ expires: 7});
                    //     } else {
                    //         this.$store.commit('user/VIPSTATUS', 'true');
                    //         localStorage.setItem("isVipStr", 'true',{ expires: 7});
                    //     }
                    // })
                } else {
                    // this.$store.commit('user/LOGINSTATUS', true);
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/css/variables.scss";
    .content-box {
        padding-bottom: 56px;
    }
    .banner-right {
        position: fixed;
        z-index: 9997;
        display: block;
        right: 16px!important;
        background-color: none!important;
        box-shadow: none!important;
        .banner-right-bottom {
            float: right;
        }
        .banner-right-small-code {
            width: 68px;
            height: 68px;
            background: #ffffff;
            border-radius: 10px;
            box-shadow: 0px 3px 6px 1px rgba(44, 46, 51, 0.1); 
            text-align: center;
            img {
                width: 32px;
                height: 32px;
                margin-top: 18px;
            }
        }
        .banner-right-code {
            width: 140px;
            background: #ffffff;
            border-radius: 10px;
            text-align: center;
            box-shadow: 0px 3px 6px 1px rgba(44, 46, 51, 0.1); 
            position: absolute;
            right: 80px;
            img {
                width: 120px;
                height: 120px;
                margin-top: 8px;
            }
            p {
                font-size: 14px;
                font-weight: 400;
                color: #5e6166;
                margin: 5px 0 12px 0;
                line-height: 20px;
            }
        }
        .banner-right-top {
            width: 68px;
            height: 68px;
            background: #ffffff;
            border-radius: 10px;
            margin-top: 16px;
            display: flex;
            float: right;
            justify-content: center;
            align-items: center;
            position: relative;
            bottom: 0px;
            box-shadow: 0px 3px 6px 1px rgba(44, 46, 51, 0.1); 
            img {
                width: 34px;
                height: 46px;
            }
        }
    }
    .compare-box {
        min-width: 68px;
        height: 185px;
        background: #ffffff;
        border-radius: 10px;
        box-shadow: 0px 3px 6px 1px rgba(44, 46, 51, 0.1); 
        position: fixed;
        z-index: 9997;
        bottom: 342px;
        text-align: center;
        padding: 16px 13px;
        right: 16px!important;
        font-size: 14px;
        color: #909399;
        cursor: pointer;
        .el-row {
            padding-top: 14px;
            margin-top: 14px;
            border-top: 1px solid #e1e4eb;
        }
        .compare-add {
            margin-bottom: 4px;
        }
        span {
            font-size: 18px;
            font-weight: 600;
            color: $common-color;
        }
        .compare-img2 {
            width: 20px;
            height: 72px;
            margin-top: 10px;
        }
        .compare-img1 {
            width: 44px;
            height: 44px;
            position: absolute;
            top: -22px;
            left: 50%;
            transform: translateX(-50%);
        }
    }
</style>